import styled from 'styled-components';

const StyledLogo = styled.div`
  width: 130px;
  font-size: 14px;
  line-height: 16px;
  width: 60px;
  font-family: 'Amorim Sans Serif', sans-serif;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 22px;

  p {
    margin: 0;
    padding: 0;
  }

  @media (min-width: 768px) {
    font-size: 20px;
    line-height: 23.5px;
    letter-spacing: 0.8px;
    padding-top: 16px;
    width: 118px;
  }
`;

export { StyledLogo }
